import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "className", "value", "valueChange", "suffixText", "prefixText", "min", "max", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot", "error", "errMessage", "ref", "defaultValue"],
    _excluded2 = ["name", "control", "rules", "containerClassName", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { Box, FormHelperText, TextField } from '@mui/material';
import clsx from 'clsx';
import CurrencyInput from 'react-currency-input-field';
import { useController } from 'react-hook-form';
import { getFormTitleComponent } from '../components';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveCurrencyInput = function JoveCurrencyInput(props) {
  var size = props.size,
      className = props.className,
      value = props.value,
      valueChange = props.valueChange,
      suffixText = props.suffixText,
      prefixText = props.prefixText,
      min = props.min,
      max = props.max,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      error = props.error,
      errMessage = props.errMessage,
      ref = props.ref,
      defaultValue = props.defaultValue,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(value),
      inputValue = _useState[0],
      setInputValue = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setInputValue(value);
  }, [value]);
  /**
   * methods
   */

  var valueChangeAction = function valueChangeAction(num) {
    var newNum = num;
    var numericValue = Number(num);

    if (num !== undefined && num !== null && num !== '' && !Number.isNaN(numericValue)) {
      newNum = numericValue;

      if (min !== undefined && newNum < min) {
        newNum = min;
      }

      if (max !== undefined && newNum > max) {
        newNum = max;
      }
    }

    valueChange === null || valueChange === void 0 ? void 0 : valueChange(newNum || null);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && getFormTitleComponent({
      formTitleSlot: formTitleSlot,
      formTitle: formTitle,
      formTitleClassName: formTitleClassName,
      formTitleDirection: formTitleDirection
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && getFormTitleComponent({
        formTitleSlot: formTitleSlot,
        formTitle: formTitle,
        formTitleClassName: formTitleClassName,
        formTitleDirection: formTitleDirection
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(CurrencyInput, _objectSpread({
          customInput: TextField,
          value: inputValue,
          onValueChange: valueChangeAction,
          size: size,
          max: 10000,
          suffix: suffixText,
          prefix: prefixText,
          inputProps: {
            className: 'focus:ring-0 focus:outline-none'
          }
        }, rest)), error && /*#__PURE__*/_jsx(FormHelperText, {
          error: error,
          children: errMessage
        })]
      })]
    })]
  });
};

export var JoveCurrencyInputontrolled = function JoveCurrencyInputontrolled(props) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      containerClassName = props.containerClassName,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveCurrencyInput, _objectSpread(_objectSpread({}, rest), {}, {
      value: value,
      valueChange: valueChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
};
export default JoveCurrencyInput;